/* eslint-disable css-modules/no-undef-class, css-modules/no-unused-class, no-nested-ternary */
import { FC, useState } from 'react';
import { Icon } from 'learning-panel-components';
import styles from './leaderboard.module.scss';

const LeaderboardCollapsed: FC<LeaderboardCollapsedProps> = (props: LeaderboardCollapsedProps) => {
    const { onExpand, rank } = props;
    const [isHovered, setIsHovered] = useState<boolean>(false);

    return (
        <div
            className={styles['leaderboard-unexpand']}
            onMouseOver={(): void => setIsHovered(true)}
            onMouseLeave={(): void => setIsHovered(false)}
            onClick={() => onExpand(true)}
        >
            {isHovered && <Icon data-testid="arrow-icon" name={'upDownExpand'} />}
            <Icon data-testid="leaderboard-icon" name="barChart" className={styles.icon} />
            <div className={styles.text}>#{rank}</div>
        </div>
    );
};

interface LeaderboardCollapsedProps {
    rank: number;
    onExpand: Function;
}

export default LeaderboardCollapsed;
